define('Components/EngagementsWidget/js/EngagementsWidget',['hooks','Components/EngagementsWidget/js/views/EngagementsWidgetInstanceView','Components/EngagementsWidget/js/models/EngagementsWidgetInstanceModel'],
    function(hooks,EngagementsWidgetInstanceView,EngagementsWidgetInstanceModel){

        return function(){
            hooks.registerWidgetInstance(
                'EngagementsWidget',
                EngagementsWidgetInstanceView,
                EngagementsWidgetInstanceModel
            );
        }

});
